<template>
    <div class="form-check">
        <input type="checkbox" class="form-check-input" :id="name" :name="name" :checked="modelValue"
            @change="onChange" />
        <label class="form-check-label" :for="name">
            <slot>
                {{ label || (modelValue ? checkedLabel : uncheckedLabel) }}
            </slot>
        </label>
    </div>
</template>

<script>
export default {
    name: "FormCheckbox",
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        checkedLabel: {
            type: String,
            default: ''
        },
        uncheckedLabel: {
            type: String,
            default: ''
        }
    },
    methods: {
        onChange(event) {
            const value = event.target.checked;
            this.$emit("update:modelValue", value);
            this.$emit("change", value);
        }
    }
};
</script>

<style scoped>
/* Optional: force checkbox visibility */
.form-check-input {
    width: 1.2em;
    height: 1.2em;
}
</style>
